export default "__VITE_ASSET__f12daa49__"